import moment from 'moment';
import newhttp from '~/http/new';
import storeUtils from '~/utils/storeUtils';

export default ({
  state: {
    leads: [],
    page: 1,
    pages: 0,
    filters: {},
    sort: {
      sort: 'registeredAt',
      sortDesc: true,
    },
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const {
        page,
        filters,
        sort,
      } = state;

      const itemsPerPage = rootGetters['common/itemsPerPage'];

      const filteredFilters = storeUtils.clearEmptyParams(filters);

      const { cumulativeCurrencyId, ...rest } = filteredFilters;

      return {
        ...rest,
        ...sort,
        fromRegisteredAt: filters.fromRegisteredAt ? moment.utc(filters.fromRegisteredAt).unix() : undefined,
        toRegisteredAt: filters.toRegisteredAt ? moment.utc(filters.toRegisteredAt).set({ hour: 23, minute: 59, second: 59 }).unix() : undefined,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      };
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },
    SET_SORT(state, data) { state.sort = data; },

    SET_LEADS(state, data) {
      state.leads = data;
    },
  },

  actions: {
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setSort({ commit }, data) { commit('SET_SORT', data); },

    async loadLeads({ getters, commit, rootGetters }, data) {
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const response = await newhttp.get('v1/p2p/trader-leads', {
        params: {
          ...getters.requestData,
          ...data,
        },
      });
      const { traderLeads, totalCount } = response.data;
      commit('SET_LEADS', traderLeads);
      if (totalCount) {
        const pages = Math.ceil(totalCount / itemsPerPage);
        commit('SET_PAGES', pages);
      }
    },
  },

  namespaced: true,
});
